export function reducer(state, action) {
    const { nSlides } = state;
    switch (action.type) {
        case "setProps":
            return { ...state, ...action.props };
        case "goTo":
            if (action.index === undefined || action.index === state.activeSlideIndex) {
                return state;
            }
            return {
                ...state,
                activeSlideIndex: action.index,
            };
        case "goToPrevious":
            return {
                ...state,
                activeSlideIndex: (nSlides + state.activeSlideIndex - 1) % nSlides,
            };
        case "goToNext":
            return {
                ...state,
                activeSlideIndex: (state.activeSlideIndex + 1) % nSlides || 0,
            };
        default: {
            const _ = action;
            throw new Error(`Unknown type: ${_}`);
        }
    }
}
//# sourceMappingURL=reducer.js.map